import { CubagesApiRemoteService } from '../../Services/api/cubages/cubages-service'
import { IUpdateCubageProductPayload } from '../../Services/api/cubages/cubages.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class UpdateCubagesUseCase
implements IFormUsecase<IUpdateCubageProductPayload, void> {
  constructor (private readonly CubagesApi: CubagesApiRemoteService) {}
    

  public async handle (
    data: IUpdateCubageProductPayload
  ): Promise<Result<void>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.CubagesApi.update(data)

      if (response.isFailure) {
        return response
      }

    
      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
